import { Injectable } from '@angular/core';
import { TabThemeConfig } from '../_interfaces';
import { AppStringsService } from '../_services';

export type TabRefTypes = 'news' | 'matches' | 'scores' | 'draws' | 'players' | 'schedule' | 'webview' | 'tournament_chat' | 'lucra_contests' | 'tournament_details' | 'tee_times';
export type TabLables = 'News' | 'Matches' | 'Scores' | 'Draws' | 'Players' | 'Schedule' | 'Chat' | string;

export interface TabConfig {
    label: TabLables
    ref: string
    bb_banner: boolean
    timeline_id?: string
    url?: string
    locale?: string | null;
}

@Injectable({
    providedIn: 'root'
})

export class TabBuilder {
    constructor(
        private appStringAPI: AppStringsService
    ) { }

    build(tab_config: TabThemeConfig[], locale?: string): { tabs: TabConfig[], active_tab?: number } {
        let ordered_tabs: TabConfig[] = [];
        const overview: TabConfig = { label: this.appStringAPI.getAppString('golf.tournament.details.tab.title'), ref: 'tournament_details', bb_banner: false };
        const chat: TabConfig = { label: this.appStringAPI.getAppString('golfchat.tournament.chat.title'), ref: 'tournament_chat', bb_banner: false };
        const leaderboard: TabConfig = { label: this.appStringAPI.getAppString('golf.leaderboard.tab.title'), ref: 'leaderboard', bb_banner: false };
        const teeTimes: TabConfig = {
          label: this.appStringAPI.getAppString('golf.tournament.teetimes.tab.title'),
          ref: 'tee_times',
          bb_banner: false
        };

        if (!tab_config) {
            ordered_tabs = []

            const active_tab = ordered_tabs[0];

            return { tabs: ordered_tabs, active_tab: ordered_tabs.indexOf(active_tab) }

        }


        tab_config.forEach((tab) => {
            switch (tab.destination) {
                case 'tournament_details': {
                    ordered_tabs.push(overview)
                    break;
                }
                case 'leaderboard': {
                    ordered_tabs.push(leaderboard)
                    break;
                }
                case 'tee_times': {
                    ordered_tabs.push(teeTimes);
                    break;
                }
                case 'tournament_chat': {
                    ordered_tabs.push(chat)
                    break;
                }
            }
        })

        return { tabs: ordered_tabs }

    }

    private handleTabLabel(value: string): string {
        const labels = new Map([
            ['brackets', 'brackets'],
            ['leaderboard_bracket', 'leaderboard'],
            ['bracket_pools', 'pool'],
            ['leaderboard_top_fans', 'leaders'],
            ['challenges', 'challenges']
        ])

        return labels.has(value) ? labels.get(value) as string : value
    }

}